import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Box} from 'reactjs-admin-lte'
import {Pagination,Button,ButtonToolbar,SplitButton,MenuItem,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwsome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import DatePicker from '../../component/element/DatePicker'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import PullStock from '../../component/element/PullStock'
import IframeModal from '../../component/element/IframeModal'
import AutopartStore from '../../stores/AutopartStore'
import SubscribeStore from '../../stores/SubscribeStore'
import ReportStore from '../../stores/ReportStore';
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');


const DEFAULT_ROW = 20
class StockCheckReport extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
  }

  initState(newState){
    
    let state = {isFirstSave:true,activePage:1,totalPage:1,cur_data:[],pullStockShow:false,loading:false,showHistory:false,soNo:'',show:false,showNotice:false,shopName:'',rowBeep:-1,data:this.newEmptyRow(DEFAULT_ROW),options:[],doc:this.getEmptyDoc()}

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }


  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData()
    }
  }

  subscribeDocChannel(channel){
    let that = this
    SubscribeStore.subscribeChannel(channel,function(jsonObj){
      //that.loadData(false)
    })     
  }

  renameDoc(newSoNo){
    let {doc} = this.state
    doc['sale_order_no'] = newSoNo
    this.setState({soNo:newSoNo,doc:doc})
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {itemnum:'',productcode:'',detail:'',stock_quantity:'',quantity:'',unit:'',remark:''}
    })
  }

  getEmptyDoc(){
    return {amount:0,customer_name:'',customer_address:'',remark:'',status:'',stock_recordid:''}
  }

  

  handleSelect(number='',pageSelect) { 
    let {cur_data} = this.state
    if (cur_data.length > 10) {
      let data = []
      let end = (pageSelect * 20) - 1
      let start = end - 19
      for (var i=start;i<=end;i++) {
        if (i<cur_data.length) {
          data.push(cur_data[i])
        }
      }

      if (number!=='') {
        data = data.concat(this.newEmptyRow(number))
        this.pcInput = new Array(data.length).fill('')
      }
      this.setState({activePage:pageSelect, data:data})
    }
  }

  loadData(shouldFocus=true){
    let {messages} = this.props 
    let that = this       
    this.setState(this.initState({loading:true}))
    StockStore.loadStockCheckItem(this.props.stockType,function(result){
      let data = result.data
      if (result.data.length>0) {
        if (result.data.length<DEFAULT_ROW)
          data = data.concat(that.newEmptyRow(DEFAULT_ROW-result.data.length))
        else
          data = data.concat(that.newEmptyRow(1))
      } else {
        data = data.concat(that.newEmptyRow(DEFAULT_ROW))
      }

      let all_data = result.data
      let totalPage = all_data.length / 20
      totalPage = Math.ceil(totalPage)
      if (totalPage > 1) {
        data = []
        for (var i=0;i<20;i++) {
          data.push(all_data[i])
        }
      } else {
        totalPage = 1
      }
      that.setState({totalPage:totalPage, cur_data:all_data})

      that.pcInput = new Array(data.length).fill('')
      that.setState({loading:false,data:data})
      if(shouldFocus){

          ReactDOM.findDOMNode(that.pcInput[data.length-1]).focus();
          
      }else{
        that._notificationSystem.addNotification({
          title: messages['Notification'],
          message: messages['Item Changed'],
          level: 'info',
          position: 'tc'
        });
      }
      
      
    },function(){
      that.setState({loading:false})
    })
  }

  onPrintClick(){
    let {soNo} = this.state
    if (process.env.NODE_ENV === "development") {
        window.open('https://demo-fast.bigfix.co/sriracha/pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }else{
        window.open('./pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }
  }

  onCustomerClick(){
    this.setState({show:true})
  }

  onInputChange(key,e){
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onCustomerPageSelect(item){
    let {doc} = this.state
    doc['customer_id'] = item.customer_id
    doc['customer_name'] = item.name
    doc['customer_address'] = item.address
    this.setState({doc:doc})
  }

  onDateChange(value){
    let {doc} = this.state
    doc['added_date'] = value
    this.setState({doc:doc})
  }

  onSaveClick(){
    let {data} = this.state
    this.saveStockCheck(data)  
  }

  saveStockCheck(data){
    let {messages} = this.props
    let that = this
    this.setState({loading:false})
    let postData = {itemlist:data}
    StockStore.saveStockCheck(this.props.stockType,postData,function(result){
      that.setState({loading:false})
      that._notificationSystem.addNotification({
        title: messages['Notification'],
        message: messages['Automatic Saving'],
        level: 'info',
        position: 'tc'
      });
      //SubscribeStore.send({function:"onSaveClick",args:[]});      
    },function(error){
      that.setState({loading:false})
    })
  }

  onCloseClick(){
    //SubscribeStore.unsubscribe()
    
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  getTotalPage() {
    let {cur_data} = this.state
    let totalPage = cur_data.length / 20
    totalPage = Math.ceil(totalPage)
    if (totalPage<=0)
      totalPage = 1

    this.setState({totalPage:totalPage})
  }
  
  onDeleteRowClick(index){ 
    let {data,cur_data} = this.state

    let start_page =  (this.state.activePage * 20) - 20
    let new_index = (start_page*1)+(index*1)

    cur_data.splice(new_index,1);
    data.splice(index,1);
    this.setState({data:data, cur_data:cur_data})    
    this.getTotalPage()
    this.saveStockCheck(cur_data)  
  }

  summaryAmount(data){
    let amount = 0
    data.map((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {doc,data} = this.state
    let value = e.target.value
    data[index][key] = value
    if(['quantity','price_per_unit'].includes(key)){
      data[index]['amount'] = data[index]['quantity']*data[index]['price_per_unit']
      doc['amount'] = this.summaryAmount(data)      
    }
    this.setState({doc:doc,data:data})
  }

  onRowAdd(number){
    let {data,totalPage,activePage} = this.state
    
    if (activePage!==totalPage) {
      this.handleSelect(number,totalPage)
    } else {
      data = data.concat(this.newEmptyRow(number))
      this.pcInput = new Array(data.length).fill('')
      this.setState({data:data})
    }
  }


  onSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1,query,function(result){
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,unit:item.unit,quantity:item.quantity,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      that.setState({options:options})
    })
    
    //this.setState({options:options})
  }

  onRequestStockDecrease(successFunc){
    let {data,soNo,doc} = this.state
    let that = this
    this.setState({loading:true})
    StockStore.requestStockDecrease(soNo,data,function(result){
      data = data.map((item,index)=>{
        if(item.itemnum>0)
          item.stock_quantity = item.stock_quantity - item.quantity
        return item
      })
      doc.stock_recordid = result.id
      that.setState({loading:false,data:data,doc:doc})
      successFunc()
    },function(error){
      that.setState({loading:false})
    })
  }

  onProductCodeSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockCodePartItemList(-1,query,function(result){
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      that.setState({options:options})
    })
  }

  onTypeaheadChange(index,option){
    let {data,doc} = this.state
    if(option.length===1){
      data[index].detail = option[0].detail
      data[index].quantity = 1
      if(option[0].itemnum!==undefined){
        data[index].amount = option[0].pricePerUnit
        data[index].itemnum = option[0].itemnum      
        data[index].stock_quantity = option[0].quantity  
        data[index].productcode = option[0].productCode
        data[index].price_per_unit = option[0].pricePerUnit
      }
      doc['amount'] = this.summaryAmount(data)
    }
    this.setState({data:data,doc:doc})
  }

  onTextKeyPress(index,key,target) {
    if(target.charCode===13){
      this.onSaveClick()
    }
  }

  onSearchKeyPress(index,key,target) {
    if(target.charCode===13){
      let {data} = this.state
      let {messages} = this.props
      let that = this,foundIndex = -1
      let productCode = data[index][key];
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      //Finding duplicate
      data.map((item,iindex)=>{
        if(item.productcode===productCode && iindex!==index){
          foundIndex = iindex
        }
      })
      if(foundIndex>=0){
        
        data[index].productcode = ''
        that.setState({loading:false,data:data,rowBeep:foundIndex})
        setTimeout(function(){ 
          that.setState({rowBeep:-1})
        }, 1500);
      }else{
        this.setState({loading:false})
        
        AutopartStore.loadStockProductCode(this.props.stockType,productCode,function(result){
          // options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
          if(result.data.length>0){
            let item = result.data[0]        
            data[index].detail = item.description        
            data[index].productcode = item.productcode
            data[index].itemnum = item.itemnum
            data[index].price_per_unit = item.price_per_unit
            data[index].quantity = ''
            data[index].amount  = item.price_per_unit
            data[index].stock_quantity = item.quantity
            data[index].unit = item.unit
            data[index].remark = item.remark
            data[index].exportStock = '0'
            

            if(index===data.length-1){
              //End index
              data = data.concat(that.newEmptyRow(1))
              that.pcInput[index+1] = ''
            }
            that.setState({loading:false,data:data})
            ReactDOM.findDOMNode(that.pcInput[index+1]).focus();
            that.saveStockCheck(data)
          }else{
            data[index].productcode = ''
            that.setState({loading:false,data:data})
            that._notificationSystem.addNotification({
              title: messages['messages'],
              message: messages['Code Not Found']+' '+productCode+' '+messages['In Warehouse'],
              level: 'warning',
              position: 'tc'
            });
          }
        })      
      }
    }
  }


  onMenuItemSelect(index){
    if('clearlist'===index){
      this.setState({clearShow:true})
    }else if("adjuststock"===index){
      this.setState({stockShow:true,isFirstSave:true})      
    }else if("print"===index){
      let url = ''
      if (process.env.NODE_ENV === "development") {
        url  = './?startPage=PrintReportStockCheck&type='+this.props.stockType
      } else{
        url = './pdf/v2/?startPage=PrintReportStockCheck&type='+this.props.stockType
      }
      this.refs.iframe.loadUrl(url)
    }else if ("pullstock"===index) {
      this.setState({pullStockShow:true})
    }
  }

  onConfirmStockClear(){
    this.setState({totalPage:1,activePage:1,clearShow:false,data:this.newEmptyRow(DEFAULT_ROW)})
    this.saveStockCheck([])
  }

  onConfirmStockSave(){
    let {data,isFirstSave} = this.state 
    let that = this
    let {messages} = this.props
    if (isFirstSave) {
      this.setState({isFirstSave:false})
      StockStore.requestStockAdjust(this.props.stockType,data,function(result){
        data = data.map((item,index)=>{
          item.stock_quantity = item.quantity
          return item
        })
        that.setState({stockShow:false,data:data})
        that._notificationSystem.addNotification({
          title: messages['Notification'],
          message: messages['Adjust Quantity Of Warehouse'],
          level: 'info',
          position: 'tc'
        });
      },function(){
        that.setState({stockShow:false})
      })
    }
  }

  onDataChange(cat_id) {
    let that = this
    let {messages} = this.props
    ReportStore.loadStockList(this.props.stockType, "", cat_id, "", "", "", function(result) {
      let data = result.data.map((item,index)=>{
        item.stock_quantity = item.quantity
        item.quantity = ''
        item.detail = item.description
        
        return item
      })
      that.setState({cur_data:data})
      if(data.length<20) {
        if (data.length>0)
          data = data.concat(that.newEmptyRow(20-data.length))
        else
          data = that.newEmptyRow(20)
        
        that.setState({data:data, totalPage:1, activePage:1})
        that.saveStockCheck(data)
      } else {
        let all_data = data
        let totalPage = all_data.length / 20
        totalPage = Math.ceil(totalPage)
        if (totalPage > 1) {
          data = []
          for (var i=0;i<20;i++) {
            data.push(all_data[i])
          }
        } else {
          totalPage = 1
        }
        that.setState({data:data, totalPage:totalPage, activePage:1})
        that.saveStockCheck(all_data)
      }

      that._notificationSystem.addNotification({
        title: messages['Notification'],
        message: messages['Pull Data Successfully'],
        level: 'info',
        position: 'tc'
      });
    })
  }

  getValidationState() {
    const length = this.state.shopName.length;
    if (length > 10) return 'success';
    else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let {messages} = this.props
    let quantityTitle = ''
    if(option.quantity>0){
      quantityTitle = ' '+messages['Have Number']+' '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} ({messages['Category']} {option.categoryName}) - {option.pricePerUnit} {messages['Bath']} {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }

  renderHeaderRow(){
    let {customer_name,customer_address,added_date} = this.state.doc
    let {messages} = this.props
    return (
      <Row>
        <Col md={3}>
          <FormGroup
            controlId="formBasicText"
            validationState={this.getValidationState()}
          >
            <ControlLabel>{messages['Customer']} :</ControlLabel>
            <InputGroup>
              <InputGroup.Addon><FontAwsome name='user'/></InputGroup.Addon>
              <FormControl value={customer_name} onChange={this.onInputChange.bind(this,'customer_name')}/>
              <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwsome name='plus'/></InputGroup.Addon>
            </InputGroup>            
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup
            controlId="formBasicText"
            validationState={this.getValidationState()}
          >
            <ControlLabel>{messages['Address']} :</ControlLabel>
            <InputGroup>
              <InputGroup.Addon><FontAwsome name='location-arrow'/></InputGroup.Addon>
              <FormControl value={customer_address} onChange={this.onInputChange.bind(this,'customer_address')}/>
            </InputGroup>            
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup
            controlId="formBasicText"
            validationState={this.getValidationState()}
          >
            <ControlLabel>{messages['Date']} :</ControlLabel>
            <InputGroup>
              <InputGroup.Addon><FontAwsome name='calendar'/></InputGroup.Addon>              
              <DatePicker style={{display:'inline-block'}}
                showIcon={false}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={added_date} 
                onChange={this.onDateChange.bind(this)}/>
            </InputGroup>            
          </FormGroup>
        </Col>
      </Row>
    )
  }

  renderRemark(){
    let {remark} = this.state.doc
    return (
      <Row>
      <Col md={3}>
        <FormGroup
          controlId="formBasicText"
          validationState={this.getValidationState()}
        >
          <ControlLabel>{this.props.messages['Note']} </ControlLabel>
          <InputGroup>            
            <FormControl value={remark} componentClass="textarea" style={{width:'400px',height:'150px'}}
             onChange={this.onInputChange.bind(this,'remark')}/>            
          </InputGroup>            
        </FormGroup>
      </Col>
      </Row>
    )
  }

  getRowClassName(item,index){
    let {rowBeep} = this.state
    let className = (item.itemnum>0)?'':(item.detail.length>0)?'bg-gray':''

    if(rowBeep===index){
      className = 'bg-yellow'      
    }
    return className
  }

  onHideClick(e) {
    this.setState({pullStockShow:e})
  }

  getDecimal(number) {
    if (isNaN(number)) {
      return 0
    } else if (number==="") { 
      return ""
    } else {
      return parseFloat(number).toFixed(2) * 1
    }
  }

  renderRowData(){
    let {data,options,activePage} = this.state
    let {messages} = this.props
    let number = 0
    if (activePage>1)
      number = activePage * 10
    return(
      data.map((item,index)=>{
        let sumQty = (item.quantity===''||item.quantity===null||item.quantity===undefined||isNaN(item.quantity)?0:item.quantity)-item.stock_quantity
        return(
          <tr key={index} className={this.getRowClassName(item,index)}>
            <td className='text-center'>{number+index+1}</td>
            <td className='data-column'>
              <FormControl className='text-left' 
              ref={(input) => { this.pcInput[index] = input; }} 
              value={item.productcode} 
              onChange={this.onFormChange.bind(this,index,'productcode')}
              onKeyPress={this.onSearchKeyPress.bind(this,index,'productcode')}
              />          
            </td>
            <td className='data-column'>        
            <AsyncTypeahead
                        allowNew={false}
                        multiple={false}
                        newSelectionPrefix={messages['Add New Item']+' : '}   
                        promptText={messages['Keypress For Searching']}           
                        searchText={messages['Searching']}                    
                        selected={[{detail:item.detail}]}
                        options={options}
                        labelKey="detail"
                        onSearch={this.onSearch.bind(this,index)}
                        onChange={this.onTypeaheadChange.bind(this,index)}
                        placeholder=""
                        renderMenuItemChildren={this._renderMenuItemChildren}
                      /> 
            </td>
            <td  className='data-column text-center'>{this.getDecimal(item.stock_quantity)}</td>
            <td  className='data-column text-center'><FormControl className='text-center' 
            value={item.quantity} 
            onChange={this.onFormChange.bind(this,index,'quantity')}
            onKeyPress={this.onTextKeyPress.bind(this,index,'quantity')}
            /></td>
            <td className={'data-column text-center'+(sumQty>0?' text-green':sumQty<0?' text-red':'')}>{item.stock_quantity!==''&&item.quantity!==''?((sumQty>0?'+':'')+sumQty):''}</td>
            <td className='data-column text-center'>{item.unit}</td>
            <td className='data-column text-center'>{item.location}</td>
            <td className='data-column text-center'>
              <FormControl 
                value={item.adjust_reason} 
                onChange={this.onFormChange.bind(this,index,'adjust_reason')}
              />
            </td>
            <td className='text-center'><Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwsome name='close'/></Button></td>
          </tr>
        )  
      })
    )    
  }


  renderTable(){
    let {doc} = this.state
    let {messages} = this.props
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1280px',marginBottom:'0'}}>
          <thead>
            <tr >
              <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
              <th className='text-center' style={{width:'150px'}}>{messages['Product Code']}</th>
              <th>{messages['Part Name']}</th>
              <th className='text-center' style={{width:'50px'}}>{messages['Quantity (In System)']}</th>
              <th className='text-center' style={{width:'50px'}}>{messages['Quantity']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Qty/Adjust']}</th>
              <th className='text-center' style={{width:'50px'}}>{messages['Unit']}</th>
              <th className='text-center' style={{width:'50px'}}>{messages['Shelf']}</th>
              <th className='text-center' style={{width:'200px'}}>{messages['Note']}</th>
              <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr >            
              <th colSpan={3} className='text-right'>{messages['Total Of Item']}</th>
              <th className='text-right'>{doc.totalQuantity}</th>
              <th className='text-right'>{doc.totalCountQuantity}</th>
              <th colSpan={5} ></th>
          </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderNewItemButton(){
    let {messages} = this.props
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwsome name='plus'/>&nbsp;{messages['Add Item']}</Button>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwsome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
          </ButtonToolbar>       
        </Col>    
      </Row>
    )
  }

  
  renderStockStatus(){
    let {doc} = this.state
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>{this.props.messages['Cut Stock']}</span>)
    }else{
      return (<span/>)
    }
  }

  renderHeadTable() {
    let {messages} = this.props
    return(
            <form style={{display:(this.props.showHead?'':'none')}}>
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>{messages['Document Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" placeholder={'<'+messages['Auto Generated Number']+'>'} className="input-dark" />
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>{messages['Date']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value='' />
                  </FormGroup>
                </Col>
              </Row>
              
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>{messages['RequesterOut']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value='' onChange='' />
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>{messages['Approvers']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value='' onChange='' />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>{messages['Description']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value='' onChange='' />
                  </FormGroup>
                </Col>
              </Row>
            </form>
    )
  }

  render(){
    let {loading,stockShow,clearShow,pullStockShow} = this.state
    let {messages} = this.props
    let title = (<span><FontAwsome name="list"/>&nbsp;{messages['Menu']}</span>)
    return (
      <div>
        <Box loading={loading}>
          <Box.Header  className='text-center'>
            <Box.Title>
              {messages['Check Stock Item']}
            </Box.Title>
            <Box.Tools className='pull-right'>
              <ButtonToolbar>                                            
                <SplitButton bsStyle={'primary'} title={title} id={'po-menu-options'} onSelect={this.onMenuItemSelect.bind(this)}>
                  <MenuItem eventKey="clearlist"><FontAwsome name='file-o' />&nbsp;{messages['Start']}</MenuItem>
                  <MenuItem eventKey="pullstock"><FontAwsome name='download' className='text-green'/>&nbsp;{messages['Pull Data']}</MenuItem>                
                  <MenuItem eventKey="adjuststock"><FontAwsome name='exchange' className='text-red'/>&nbsp;{messages['Adjust Quantity']}</MenuItem>                
                  <MenuItem divider />
                  <MenuItem eventKey="print"><FontAwsome name='print' className='text-blue'/>&nbsp;{messages['Print Report']}</MenuItem>                
                </SplitButton>
              </ButtonToolbar>                     
            </Box.Tools> 
          </Box.Header>
          <Box.Body>
            {this.renderHeadTable()}
            {this.renderTable()}
            {this.renderNewItemButton()} 
            <IframeModal ref='iframe' title={messages['Print Document']} />
            <NotificationSystem ref="notificationSystem" />
            <ConfirmPopup show={stockShow} 
              title={messages['Confirm Title']} 
              message={messages['Want To Update The Stock From This Item']}
              confirmTitle={messages['Confirm']}
              onConfirm={this.onConfirmStockSave.bind(this)}
              onHide={()=>{this.setState({stockShow:false})}}        
              /> 
            <ConfirmPopup show={clearShow} 
              title={messages['Confirm Title']}
              message={messages['Want To Start New Stock']}
              confirmTitle={messages['Confirm']}
              onConfirm={this.onConfirmStockClear.bind(this)}
              onHide={()=>{this.setState({clearShow:false})}}        
              /> 
            <PullStock
              show={pullStockShow}
              onHide={this.onHideClick.bind(this)}
              stockType={this.props.stockType}
              onDataChange={this.onDataChange.bind(this)}
            />      
          </Box.Body>        
        </Box>
        <div>
          <div className="text-right">
            <Pagination
              prev={messages['Previous']}
              next={messages['Next']}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this,'')}
            />
          </div>
        </div>
      </div>
    )
  }
}

StockCheckReport.defaultProps = {
  show:false,
  showHead: false,
  title: 'รายการเช็คสต๊อก'
}

export default connect(
  (state) => ({messages: state.message.view.stock.StockCheckReport}),null,null,{withRef:true},
)(StockCheckReport);



// WEBPACK FOOTER //
// ./src/view/stock/StockCheckReport.js